export default __webpack_public_path__ + "984f6fe.png";